import React, { useState } from "react";
import { debounce } from "lodash";
import CourseImage from "../../CourseImageUpload";
import CourseVideo from "../../CourseVideoUpload";
import { CourseSection } from "./CourseSection";
import { Loading } from "../../../../../Other/Loading";
import Quiz from "./Quiz";
import {
  CourseBuilderStaticData,
  CourseBuilderWebinar,
} from "../../../../../../_constants/staticData";
import WebinarScheduler from "./WebinarSchedular";
import TextEditor from "./TextEditor";
import axios from "axios";
import { useEffect } from "react";
const CourseBuilderMain = ({
  formValues,
  storedSession,
  handleInputChange,
  validateDuplicateText,
  errors,
  removeFormFields,
  addFormFields,
  quizValidateMsg,
  setQuizResponse,
  setQuizValidateMsg,
  current,
  setFormValues,
  formState,
  activeSection,
  setActiveSection,
  imageFiles,
  Editvideo,
  history,
  next,
  setQuizCreation,
  quizCreation,
  quizResponse,
  coursebuilderToggle,
  quizStatus,
  location,
}) => {
  const [bundleSelectedCourse, setbundleSelectedCourse] = useState([]);
  const bindEditorState = (accessor, index, editorState, items) => {
    if (accessor) {
      if (items[index]) {
        items[index][accessor] = editorState;
        return items;
      } else {
        return items;
      }
    } else {
      return editorState;
    }
  };
  const [numError, setNumError] = useState("");
  const [other, setOther] = useState(false);
  const [dimension, setDimension] = useState(false);
  const handleEditorStateChange = (name, accessor = null, index = null) =>
    debounce((editorState) => {
      setFormValues((state) => ({
        ...state,
        [name]: bindEditorState(accessor, index, editorState, [
          ...state.courseSections,
        ]),
      }));
    }, 500);

  const courseImageFile = (content) => {
    if (content.length > 0) {
      setFormValues({
        ...formValues,
        imageFiles: [...formValues.imageFiles, content],
      });
    } else {
      setFormValues({ ...formValues, imageFiles: [] });
    }
  };

  const courseVideoFile = (content) => {
    if (content.length > 0) {
      setFormValues({
        ...formValues,
        videoFiles: [...formValues.videoFiles, content],
      });
    } else {
      setFormValues({ ...formValues, videoFiles: [] });
    }
  };

  const courseFile = (sectionIndex, formValues) => (content) => {
    if (content != null && typeof content == "object" && content.length > 0) {
      const filterScromData = content.filter(
        (items) => items.type === "application/x-zip-compressed"
      );
      const filterFilesData = content.filter(
        (items) => items.type !== "application/x-zip-compressed"
      );
      if (filterScromData) {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].scroms = filterScromData;
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
      if (filterFilesData) {
        const previousCourseSection = [...formValues.courseSections];
        previousCourseSection[sectionIndex].files = filterFilesData;
        setFormValues({
          ...formValues,
          courseSections: previousCourseSection,
        });
      }
    }
  };
  const [quizShow, setQuizShow] = useState(false);
  const otherLang = () => {
    setOther(!other);
  };

  const checkIfNumber = (event) => {
    const regex = new RegExp(
      /(^\d*$)|(Backspace|Tab|Delete|ArrowLeft|ArrowRight)/
    );
    if (!event.key.match(regex)) {
      setNumError("*Please enter a number ");
    } else {
      setNumError("");
    }

    return !event.key.match(regex) && event.preventDefault();
  };

  return (
    <>
      {storedSession !== "liveCourse" && (
        <div
          className={`${
            coursebuilderToggle ? "align-box" : "align-box-1"
          } align-top`}
        >
          <div className={current === 8 ? "define-page" : "occlude"}>
            <h3 className="define-headeline">
              {CourseBuilderStaticData.step8.header}
            </h3>

            <p>
              {location === "createBundle"
                ? CourseBuilderStaticData.step8.bundlesubHeader1
                : CourseBuilderStaticData.step8.subHeader1}
            </p>

            <p>
              {location === "createBundle"
                ? CourseBuilderStaticData.step8.bundlesubHeader2
                : CourseBuilderStaticData.step8.subHeader2}
            </p>
            <p>
              {location === "createBundle"
                ? CourseBuilderStaticData.step8.bundlesubHeader3
                : CourseBuilderStaticData.step8.subHeader3}
            </p>

            <div className="define-add-input">
              {formValues &&
                formValues.goals &&
                formValues.goals.map((item, index) => (
                  <div className="form-inline" key={index}>
                    <input
                      type="text"
                      name="goals"
                      placeholder="Define goal "
                      value={item.name}
                      className={
                        errors.goals.filter((item) => item.id === index)
                          .length > 0
                          ? "error"
                          : ""
                      }
                      onChange={({ target }) =>
                        handleInputChange(
                          index,
                          target.name,
                          target.value,
                          "name"
                        )
                      }
                      onBlur={({ target }) =>
                        validateDuplicateText(
                          target.value,
                          index,
                          target.name,
                          [...formValues.goals.filter((_, i) => i !== index)]
                        )
                      }
                      disabled={
                        errors.goals.length > 0 &&
                        errors.goals.some((item) => item.id !== index)
                      }
                    />
                    <div className="input-validations">
                      {errors.goals.some((item) => item.id === index) && (
                        <span className="input-error">Duplicate text</span>
                      )}
                      {/* <span className="input-char">
                        {" "}
                        Character remaining {120 - item.name.length}{" "}
                      </span> */}
                    </div>

                    {formValues &&
                      formValues.goals.length > 2 &&
                      formValues.goals.length === index + 1 && (
                        <div className="define-add-text align-remove-text">
                          <img
                            name="goals"
                            role="button"
                            href="javascript(void);"
                            onClick={(event) =>
                              removeFormFields(event, index, event.target.name)
                            }
                            src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                            alt=""
                          />
                        </div>
                      )}
                  </div>
                ))}
            </div>

            <div className="define-add-text">
              <a
                href="javascript(void);"
                onClick={(event) =>
                  addFormFields(
                    event,
                    "goals",
                    10,
                    formValues,
                    errors,
                    { name: "" },
                    true
                  )
                }
              >
                + Add More Fields
              </a>
            </div>
          </div>
        </div>
      )}

      {storedSession !== "liveCourse" && (
        <div
          className={`${
            coursebuilderToggle ? "align-box" : "align-box-1"
          } align-top`}
        >
          <div className={current === 9 ? "define-page width-100" : "occlude"}>
            <h3 className="define-headeline">
              {location
                ? CourseBuilderStaticData.step8_1.bundleheader
                : CourseBuilderStaticData.step8_1.header}{" "}
              (optional)
            </h3>

            <p>
              <i>
                {location
                  ? CourseBuilderStaticData.step8_1.bundlesubHeader1
                  : CourseBuilderStaticData.step8_1.subHeader1}
              </i>
            </p>

            <p>
              {location
                ? CourseBuilderStaticData.step8_1.bundlesubHeader2
                : CourseBuilderStaticData.step8_1.subHeader2}
            </p>

            <div className="define-add-input">
              <div className="form-inline">
                <input
                  type="text"
                  name="courseOneLiner"
                  placeholder="Course one liner of this course"
                  value={formValues.courseOneLiner}
                  maxLength={120}
                  onChange={(event) =>
                    setFormValues({
                      ...formValues,
                      [event.target.name]: event.target.value,
                    })
                  }
                />
                <span>
                  Character remaining {120 - formValues.courseOneLiner.length}{" "}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}

      {!location && (
        <>
          {storedSession !== "liveCourse" && (
            <div
              className={`${
                coursebuilderToggle ? "align-box" : "align-box-1"
              } align-top`}
            >
              <div
                className={current === 10 ? "define-page width-100" : "occlude"}
              >
                <h3 className="define-headeline">
                  {CourseBuilderStaticData.step8_2.header} (optional)
                </h3>

                <p>
                  <i>{CourseBuilderStaticData.step8_2.subHeader1}</i>
                </p>

                <p>{CourseBuilderStaticData.step8_2.subHeader2}</p>

                <TextEditor
                  formState={formValues.courseOutDescription}
                  handleEditorStateChange={handleEditorStateChange(
                    "courseOutDescription"
                  )}
                  history={history}
                />
              </div>
            </div>
          )}
        </>
      )}

      {location === "createBundle" ? (
        <div className="align-box align-top">
          <div className={current === 10 ? "define-page width-100" : "occlude"}>
            <h3 className="define-headeline">Prerequisities</h3>

            <p>
              <i>{CourseBuilderStaticData.step9.bundlesubHeader1}</i>
            </p>

            <p>{CourseBuilderStaticData.step9.subHeader2}</p>

            <div className="define-add-input">
              {formValues.preRequisites.map((item, index) => (
                <div className="form-inline" key={index}>
                  <input
                    type="text"
                    className={
                      errors.preRequisites.filter((item) => item.id === index)
                        .length > 0
                        ? "error"
                        : ""
                    }
                    name="preRequisites"
                    placeholder="Pre-requisites or qualification for this course"
                    value={item.name}
                    onChange={({ target }) =>
                      handleInputChange(
                        index,
                        target.name,
                        target.value,
                        "name"
                      )
                    }
                    onBlur={({ target }) =>
                      validateDuplicateText(target.value, index, target.name, [
                        ...formValues.preRequisites.filter(
                          (_, i) => i !== index
                        ),
                      ])
                    }
                    disabled={
                      errors.preRequisites.length > 0 &&
                      errors.preRequisites.some((item) => item.id !== index)
                    }
                  />
                  <span>Character remaining {120 - item.name.length} </span>

                  {index > 0 && (
                    <img
                      href="javascript(void);"
                      name="preRequisites"
                      className="align-textRemove"
                      onClick={(event) =>
                        removeFormFields(event, index, event.target.name)
                      }
                      src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                      alt=""
                    />
                  )}
                </div>
              ))}
            </div>

            <div className="define-add-text">
              <a
                href="javascript(void);"
                name="preRequisites"
                onClick={(event) =>
                  addFormFields(
                    event,
                    event.target.name,
                    5,
                    formValues,
                    errors,
                    { name: "" },
                    true
                  )
                }
              >
                + Add More Fields
              </a>
            </div>
          </div>
        </div>
      ) : (
        <>
          {storedSession !== "liveCourse" && (
            <div className="align-box align-top">
              <div
                className={current === 11 ? "define-page width-100" : "occlude"}
              >
                <h3 className="define-headeline">
                  {CourseBuilderStaticData.step9.header} (optional)
                </h3>

                <p>
                  <i>{CourseBuilderStaticData.step9.subHeader1}</i>
                </p>

                <p>{CourseBuilderStaticData.step9.subHeader2}</p>

                <div className="define-add-input">
                  {formValues.preRequisites.map((item, index) => (
                    <div className="form-inline" key={index}>
                      <input
                        type="text"
                        className={
                          errors.preRequisites.filter(
                            (item) => item.id === index
                          ).length > 0
                            ? "error"
                            : ""
                        }
                        name="preRequisites"
                        placeholder="Pre-requisites or qualification for this course"
                        value={item.name}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "name"
                          )
                        }
                        onBlur={({ target }) =>
                          validateDuplicateText(
                            target.value,
                            index,
                            target.name,
                            [
                              ...formValues.preRequisites.filter(
                                (_, i) => i !== index
                              ),
                            ]
                          )
                        }
                        disabled={
                          errors.preRequisites.length > 0 &&
                          errors.preRequisites.some((item) => item.id !== index)
                        }
                      />
                      <span>Character remaining {120 - item.name.length} </span>

                      {index > 0 && (
                        <img
                          href="javascript(void);"
                          name="preRequisites"
                          className="align-textRemove"
                          onClick={(event) =>
                            removeFormFields(event, index, event.target.name)
                          }
                          src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                          alt=""
                        />
                      )}
                    </div>
                  ))}
                </div>

                <div className="define-add-text">
                  <a
                    href="javascript(void);"
                    name="preRequisites"
                    onClick={(event) =>
                      addFormFields(
                        event,
                        event.target.name,
                        5,
                        formValues,
                        errors,
                        { name: "" },
                        true
                      )
                    }
                  >
                    + Add More Fields
                  </a>
                </div>
              </div>
            </div>
          )}
        </>
      )}

      <div
        className={`${
          coursebuilderToggle ? "align-box" : "align-box-1"
        } align-top`}
      >
        <div
          className={
            current ===
            (storedSession === "liveCourse"
              ? 9
              : location === "createBundle"
              ? 11
              : 12)
              ? "define-page"
              : "occlude"
          }
        >
          <h3 className="define-headeline">
            {location
              ? "Course Bundle Description in Detail"
              : CourseBuilderStaticData.step10.header}
          </h3>

          <p>
            <i>
              {location === "createBundle"
                ? CourseBuilderStaticData.step10.bundlesubHeader1
                : CourseBuilderStaticData.step10.subHeader1}
            </i>
          </p>

          <p>
            {location === "createBundle"
              ? CourseBuilderStaticData.step10.bundlesubHeader2
              : CourseBuilderStaticData.step10.subHeader2}
          </p>

          <TextEditor
            formState={formValues.description}
            handleEditorStateChange={handleEditorStateChange("description")}
            history={history}
          />
        </div>
      </div>

      {location === "createBundle" ? (
        <>
          <div
            className={`${
              coursebuilderToggle ? "align-box" : "align-box-1"
            } align-top`}
          >
            <div className={current === 12 ? "define-page" : "occlude"}>
              <h3 className="define-headeline">Course Bundle FAQs</h3>

              <h4>{CourseBuilderStaticData.step11.bundleheader2}</h4>

              <p>{CourseBuilderStaticData.step11.bundlesubHeader}</p>

              <div className="define-add-input">
                {formValues.faqs.map((element, index) => (
                  <div className="form-inline" key={index}>
                    <label>Question {index + 1}</label>
                    <input
                      type="text"
                      name="question"
                      placeholder={`FAQ's question ${index + 1}`}
                      value={element.question}
                      onChange={({ target }) =>
                        handleInputChange(
                          index,
                          "faqs",
                          target.value,
                          target.name
                        )
                      }
                      // onBlur={(event) =>
                      //   validateDuplicateText(
                      //     event.target.value,
                      //     index,
                      //     "courseFAQs",
                      //     [
                      //       ...formValues.courseFAQs.filter(
                      //         (_, i) => i !== index
                      //       ),
                      //     ]
                      //   )
                      // }
                    />
                    {/* <span>
                      Character remaining {120 - element.question.length}{" "}
                    </span> */}
                    <label>Answer</label>
                    <input
                      type="text"
                      name="answer"
                      placeholder={`FAQ's answer ${index + 1}`}
                      value={element.answer}
                      onChange={({ target }) =>
                        handleInputChange(
                          index,
                          "faqs",
                          target.value,
                          target.name
                        )
                      }
                      // onBlur={(event) =>
                      //   validateDuplicateText(
                      //     event.target.value,
                      //     index,
                      //     "courseFAQs",
                      //     [
                      //       ...formValues.courseFAQs.filter(
                      //         (_, i) => i !== index
                      //       ),
                      //     ]
                      //   )
                      // }
                    />
                    {/* <span>
                      Character remaining {120 - element.answer.length}
                    </span> */}

                    {index > 0 ? (
                      <img
                        name="faqs"
                        href="javascript(void);"
                        className="align-textRemove faq"
                        onClick={(event) =>
                          removeFormFields(event, index, event.target.name)
                        }
                        src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                        alt=""
                      />
                    ) : null}
                  </div>
                ))}
                <div className="define-add-text">
                  <a
                    href="javascript(void);"
                    onClick={(event) =>
                      addFormFields(
                        event,
                        "faqs",
                        10,
                        formValues,
                        errors,
                        {
                          question: "",
                          answer: "",
                        },
                        true
                      )
                    }
                  >
                    + Add More Fields
                  </a>
                </div>

                <div>
                  <button
                    className="btn mar-left-10 nextbutton upper"
                    onClick={() => {
                      next();
                    }}
                  >
                    Skip
                  </button>
                </div>
              </div>
            </div>
          </div>
          {!location && (
            <div
              className={`${
                coursebuilderToggle ? "align-box" : "align-box-1"
              } align-top`}
            >
              <div className={current === 13 ? "define-page" : "occlude"}>
                <h3 className="define-headeline">
                  {CourseBuilderStaticData.step12.header}
                </h3>

                <p>
                  <i>{CourseBuilderStaticData.step12.subHeader1}</i>
                </p>

                <p>{CourseBuilderStaticData.step12.subHeader2}</p>

                <div className="define-add-input">
                  {formValues.syllabus.map((item, index) => (
                    <div className="form-inline" key={index}>
                      <input
                        type="text"
                        name="syllabus"
                        placeholder={`Syllabus item index ${index + 1}`}
                        value={item.name}
                        // maxLength={120}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "name"
                          )
                        }
                      />
                      {/* <span>Character remaining {120 - item.name.length} </span> */}

                      {index > 0 ? (
                        <img
                          href="javascript(void);"
                          name="syllabus"
                          className="align-textRemove"
                          onClick={(event) =>
                            removeFormFields(event, index, event.target.name)
                          }
                          src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                          alt=""
                        />
                      ) : null}
                    </div>
                  ))}
                  <div className="define-add-text">
                    <a
                      href="javascript(void);"
                      onClick={(event) =>
                        addFormFields(
                          event,
                          "syllabus",
                          100,
                          formValues,
                          errors,
                          { name: "" },
                          true
                        )
                      }
                    >
                      + Add More Content Fields
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <>
          {storedSession !== "liveCourse" && (
            <>
              <div
                className={`${
                  coursebuilderToggle ? "align-box" : "align-box-1"
                } align-top`}
              >
                <div className={current === 13 ? "define-page" : "occlude"}>
                  <h3 className="define-headeline">
                    {CourseBuilderStaticData.step11.header1}
                  </h3>

                  <h4>{CourseBuilderStaticData.step11.header2}</h4>

                  <p>{CourseBuilderStaticData.step11.subHeader}</p>

                  <div className="define-add-input">
                    {formValues.faqs.map((element, index) => (
                      <div className="form-inline" key={index}>
                        <label>Question {index + 1}</label>
                        <input
                          type="text"
                          name="question"
                          placeholder={`FAQ's question ${index + 1}`}
                          value={element.question}
                          onChange={({ target }) =>
                            handleInputChange(
                              index,
                              "faqs",
                              target.value,
                              target.name
                            )
                          }
                          // onBlur={(event) =>
                          //   validateDuplicateText(
                          //     event.target.value,
                          //     index,
                          //     "courseFAQs",
                          //     [
                          //       ...formValues.courseFAQs.filter(
                          //         (_, i) => i !== index
                          //       ),
                          //     ]
                          //   )
                          // }
                        />
                        {/* <span>
                      Character remaining {120 - element.question.length}{" "}
                    </span> */}
                        <label>Answer</label>
                        <input
                          type="text"
                          name="answer"
                          placeholder={`FAQ's answer ${index + 1}`}
                          value={element.answer}
                          onChange={({ target }) =>
                            handleInputChange(
                              index,
                              "faqs",
                              target.value,
                              target.name
                            )
                          }
                          // onBlur={(event) =>
                          //   validateDuplicateText(
                          //     event.target.value,
                          //     index,
                          //     "courseFAQs",
                          //     [
                          //       ...formValues.courseFAQs.filter(
                          //         (_, i) => i !== index
                          //       ),
                          //     ]
                          //   )
                          // }
                        />
                        {/* <span>
                      Character remaining {120 - element.answer.length}
                    </span> */}

                        {index > 0 ? (
                          <img
                            name="faqs"
                            href="javascript(void);"
                            className="align-textRemove faq"
                            onClick={(event) =>
                              removeFormFields(event, index, event.target.name)
                            }
                            src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                            alt=""
                          />
                        ) : null}
                      </div>
                    ))}
                    <div className="define-add-text">
                      <a
                        href="javascript(void);"
                        onClick={(event) =>
                          addFormFields(
                            event,
                            "faqs",
                            10,
                            formValues,
                            errors,
                            {
                              question: "",
                              answer: "",
                            },
                            true
                          )
                        }
                      >
                        + Add More Fields
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {!location && (
                <div
                  className={`${
                    coursebuilderToggle ? "align-box" : "align-box-1"
                  } align-top`}
                >
                  <div className={current === 14 ? "define-page" : "occlude"}>
                    <h3 className="define-headeline">
                      {CourseBuilderStaticData.step12.header}
                    </h3>

                    <p>
                      <i>{CourseBuilderStaticData.step12.subHeader1}</i>
                    </p>

                    <p>{CourseBuilderStaticData.step12.subHeader2}</p>

                    <div className="define-add-input">
                      {formValues.syllabus.map((item, index) => (
                        <div className="form-inline" key={index}>
                          <input
                            type="text"
                            name="syllabus"
                            placeholder={`Syllabus item index ${index + 1}`}
                            value={item.name}
                            // maxLength={120}
                            onChange={({ target }) =>
                              handleInputChange(
                                index,
                                target.name,
                                target.value,
                                "name"
                              )
                            }
                          />
                          {/* <span>Character remaining {120 - item.name.length} </span> */}

                          {index > 0 ? (
                            <img
                              href="javascript(void);"
                              name="syllabus"
                              className="align-textRemove"
                              onClick={(event) =>
                                removeFormFields(
                                  event,
                                  index,
                                  event.target.name
                                )
                              }
                              src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-trash.svg`}
                              alt=""
                            />
                          ) : null}
                        </div>
                      ))}
                      {formValues.syllabus.length <= 4 && (
                        <div className="define-add-text">
                          <a
                            href="javascript(void);"
                            onClick={(event) =>
                              addFormFields(
                                event,
                                "syllabus",
                                100,
                                formValues,
                                errors,
                                { name: "" },
                                true
                              )
                            }
                          >
                            + Add More Content Fields
                          </a>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </>
      )}

      <div
        className={`${
          coursebuilderToggle ? "align-box" : "align-box-1"
        } align-top`}
      >
        <div
          className={
            current ===
            (storedSession === "liveCourse"
              ? 10
              : location === "createBundle"
              ? 13
              : 15)
              ? "define-page"
              : "occlude"
          }
        >
          <h3 className="define-headeline">
            {location === "createBundle"
              ? CourseBuilderStaticData.step13.bundleheader1
              : CourseBuilderStaticData.step13.header1}
          </h3>

          <p>
            {" "}
            {location === "createBundle"
              ? CourseBuilderStaticData.step13.bundlesubHeader1
              : CourseBuilderStaticData.step13.subHeader1}
          </p>
          <div className="category-item  level-option">
            <select
              className="category level-section"
              aria-label="level"
              id="Category"
              name="level"
              onChange={(event) =>
                setFormValues({
                  ...formValues,
                  [event.target.name]: event.target.value,
                })
              }
              defaultValue={formValues.level}
            >
              <option value="">Select level of this course</option>
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Expert">Expert</option>
              <option value="Pro">Pro</option>
            </select>
          </div>
          <div className="define-page">
            <p>
              {location === "createBundle"
                ? CourseBuilderStaticData.step13.bundlesubHeader2
                : CourseBuilderStaticData.step13.subHeader2}
            </p>
            <div className="category-item  level-option">
              <select
                aria-label="language"
                className="category level-section"
                id="Category"
                name="language"
                onChange={(event) =>
                  setFormValues({
                    ...formValues,
                    [event.target.name]: event.target.value,
                  })
                }
              >
                <option>Choose a language</option>
                <option value="English">English</option>
                <option value="Spanish">Spanish</option>
                <option value="French">French</option>
                <option value="Russian">Russian</option>

                <option value="Hindi">Hindi</option>

                <option value="Arabic">Arabic</option>
                <option value="Portuguese">Portuguese</option>
                <option value="Indonesian">Indonesian</option>
                <option value=" Russian">Russian</option>
                <option value="Japanese">Japanese</option>
                <option value="Mandarin Chinese">Mandarin Chinese</option>
              </select>
            </div>
          </div>
          <div className="define-add-text plus" onClick={otherLang}>
            <span>+</span>
            <div>
              <h3>
                {location === "createBundle"
                  ? CourseBuilderStaticData.step13.bundleheader2
                  : CourseBuilderStaticData.step13.header2}
              </h3>
              <p>
                {location === "createBundle"
                  ? CourseBuilderStaticData.step13.bundleheader3
                  : CourseBuilderStaticData.step13.subHeader3}
              </p>
            </div>
          </div>
          {other && (
            <div className="form-inline ">
              <input type="text" name="other" className="other-lang" />
            </div>
          )}
          <div className="define-add-text">
            <h3>{CourseBuilderStaticData.step13.header3}</h3>

            <p>
              {location === "createBundle"
                ? CourseBuilderStaticData.step13.bundlesubHeader4
                : CourseBuilderStaticData.step13.subHeader4}
            </p>
            <div className="form-inline">
              <input
                aria-label="duration"
                type="number"
                onKeyDown={(event) => checkIfNumber(event)}
                className="hours"
                name="duration"
                value={formValues.duration}
                onChange={({ target }) =>
                  setFormValues({
                    ...formValues,
                    duration: target.value,
                  })
                }
              />
              <label>{CourseBuilderStaticData.step13.label}</label>
            </div>
            <span className="num-error-msg-show">
              {numError !== "" && numError}
            </span>
          </div>
          <div>
                <label>Course closing date</label><br/>
                <input type="date" 
                  value={formValues.courseDate}
                  onChange={({ target }) =>
                    setFormValues({
                      ...formValues,
                      courseDate: target.value,
                    })
                }
                className="p-3 border rounded-lg my-5"/>
          </div>
        </div>
      </div>

      <div
        className={`${
          coursebuilderToggle ? "align-box" : "align-box-1"
        } align-top`}
      >
        <div
          className={
            current ===
            (storedSession === "liveCourse"
              ? 11
              : location === "createBundle"
              ? 14
              : 16)
              ? "define-page"
              : "occlude"
          }
        >
          <h3 className="define-headeline">
            {location === "createBundle"
              ? "Add Course Bundle Image"
              : CourseBuilderStaticData.step14.header}
          </h3>
          <p>
            {location === "createBundle"
              ? CourseBuilderStaticData.step14.bundlesubHeader1
              : CourseBuilderStaticData.step14.subHeader1}
          </p>
          <p>
            {CourseBuilderStaticData.step14.subHeader2}{" "}
            <span
              className="dimensionDetails"
              onClick={() => setDimension(!dimension)}
            >
              Please click here
            </span>
          </p>

          {dimension && <p>Size should be 540 x 400px</p>}
          <div className="course-image-introductionSection">
            <CourseImage
              courseImageFileLimit={1}
              courseImageFile={courseImageFile}
              edit={imageFiles}
              history={history}
              isCourseBundle={location === "createBundle" ? true : false}
            />
          </div>
          <p className="imp">Important</p>
          <p>
            {location === "createBundle"
              ? CourseBuilderStaticData.step14.bundlesubHeader3
              : CourseBuilderStaticData.step14.subHeader3}
          </p>
        </div>
      </div>

      {location === "createBundle" && (
        <div
          className={`${
            coursebuilderToggle ? "align-box" : "align-box-1"
          } align-top`}
        >
          <div className={current === 15 ? "define-page" : "occlude"}>
            <h3 className="define-headeline">What's Included in this bundle</h3>
            {history?.location?.state?.courseSelected.map((ele, index) => (
              <div key={index} className="border-bottom-courseBundle">
                <div className="main-conatiner-course-bundle">
                  <div>
                    <h4 className="bundle-Section">{ele.CourseName}</h4>
                    <div className="courseSelected-flex">
                      <div>{ele.Category}</div>
                      <p>
                        <strong>Duration:</strong>
                        {ele.Duration === ""
                          ? "Duration Not found"
                          : `${ele.Duration} hrs`}
                      </p>
                      <p>
                        <strong>Language:</strong>
                        {ele.Language}
                      </p>
                      <p>
                        <strong>Subtitles:</strong>English
                      </p>
                    </div>
                  </div>
                  <div>
                    <img
                      src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                      width={"20px"}
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {location !== "createBundle" && (
        <>
          {storedSession !== "liveCourse" && (
            <>
              <div
                className={`${
                  coursebuilderToggle ? "align-box" : "align-box-1"
                } align-top`}
              >
                <div className={current === 17 ? "define-page" : "occlude"}>
                  <h3 className="define-headeline">
                    {CourseBuilderStaticData.step15.header1}
                  </h3>
                  <p>{CourseBuilderStaticData.step15.subHeader1}</p>

                  <div className="course-image-introductionSection CourseVideoTrailer">
                    <CourseVideo
                      courseVideoFileLimit={3}
                      courseVideoFile={courseVideoFile}
                      getEdit={Editvideo}
                      current={current}
                      history={history}
                    />
                  </div>
                  <h4>{CourseBuilderStaticData.step15.header2}</h4>
                  <p>{CourseBuilderStaticData.step15.subHeader2}</p>
                </div>
              </div>

              <div
                className={`${
                  coursebuilderToggle ? "align-box" : "align-box-1"
                } align-top`}
              >
                <div className={current === 18 ? "define-page" : "occlude"}>
                  <h3 className="define-headeline">
                    {CourseBuilderStaticData.step16.header1}
                  </h3>
                  <p>{CourseBuilderStaticData.step16.subHeader1}</p>
                  <p>{CourseBuilderStaticData.step16.subHeader2}</p>
                  <p>
                    {CourseBuilderStaticData.step16.subHeader3}
                    <em> {CourseBuilderStaticData.step16.em1}</em>.
                  </p>
                  {/* <p>
                {CourseBuilderStaticData.step16.subHeader4}{" "}
                <em>{CourseBuilderStaticData.step16.em1}</em>.
              </p> */}
                  <p>
                    For course materials,{" "}
                    <em>{CourseBuilderStaticData.step16.em3}</em>
                  </p>
                  {formValues.courseSections.map((section, index) => (
                    <div key={index}>
                      <CourseSection
                        current={current}
                        index={index}
                        section={section}
                        handleEditorStateChange={handleEditorStateChange}
                        handleInputChange={handleInputChange}
                        courseFile={courseFile(index, formValues)}
                        removeFormFields={removeFormFields}
                        history={history}
                        syllabusList={formValues.syllabus}
                      />
                    </div>
                  ))}

                  {formValues.courseSections.length < 200 && (
                    <div className="define-add-text">
                      <button
                        className="btn next mar-right-10"
                        onClick={(event) =>
                          addFormFields(
                            event,
                            "courseSections",
                            200,
                            {
                              ...formValues,
                              courseSections: [
                                ...formValues.courseSections.map(
                                  ({ name, description }) => ({
                                    name,
                                    description: JSON.stringify(description),
                                  })
                                ),
                              ],
                            },
                            errors,
                            {
                              name: "",
                              description: null,
                              videoLink: "",
                              files: [],
                            },
                            true
                          )
                        }
                      >
                        Add New Section
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}

      <div
        className={`${
          coursebuilderToggle ? "align-box" : "align-box-1"
        } align-top`}
      >
        <div
          className={
            current ===
            (storedSession === "liveCourse"
              ? 12
              : location === "createBundle"
              ? 16
              : 19)
              ? "define-page"
              : "occlude"
          }
        >
          <h3 className="define-headeline">
            {location
              ? "Price Your Course Bundle"
              : CourseBuilderStaticData.step17.header1}
          </h3>
          <p>
            {location === "createBundle"
              ? CourseBuilderStaticData.step17.bundlesubHeader1
              : CourseBuilderStaticData.step17.subHeader1}
          </p>
          {!location && (
            <div className="price-section">
              <input
                aria-label="price selection"
                type="checkbox"
                checked={formValues.isFree}
                onChange={() => {
                  setFormValues({
                    ...formValues,
                    isFree: !formValues.isFree,
                  });
                }}
              />

              <p>
                {location === "create"
                  ? CourseBuilderStaticData.step17.bundlesubHeader2
                  : CourseBuilderStaticData.step17.subHeader2}
              </p>
            </div>
          )}

          {!formValues.isFree && (
            <div>
              <div className="price-inner-cost">
                <div className="define-add-input price-inner-cost-inner">
                  <input
                    type="text"
                    name="enrollmentFee"
                    id="enrollmentFee"
                    value="INR"
                    readOnly
                  />
                </div>
                <div className="define-add-input price-inner-cost-inner">
                  <input
                    type="number"
                    placeholder="Enter your price"
                    name="enrollmentFee"
                    id="enrollmentFee"
                    value={
                      formValues.enrollmentFee !== 0 && formValues.enrollmentFee
                    }
                    onChange={({ target }) =>
                      setFormValues({
                        ...formValues,
                        enrollmentFee: target.value,
                      })
                    }
                  />
                </div>
              </div>
              <h4>{CourseBuilderStaticData.step17.header2}</h4>
              {/* <p>{CourseBuilderStaticData.step17.subHeader3} </p> */}
              {/* 
              <div className="price-inner-cost-inner">
                <select
                  aria-label="Category"
                  className="category"
                  id="Category"
                  name="Category"
                  value={formValues.promotionalOffer}
                  onChange={({ target }) => {
                    setFormValues({
                      ...formValues,
                      promotionalOffer: target.value === "true",
                      promotionalCode:
                        target.value === "true"
                          ? formValues.promotionalCode
                          : "",
                    });
                  }}
                >
                  <option value="" hidden>
                    Discount promo CODE
                  </option>
                  <option value="true">Yes, I want a code</option>
                  <option value="false">No, I do not want a code</option>
                </select>
              </div>
              {formValues.promotionalOffer && (
                <div className="define-add-input price-inner-cost-inner-promocode">
                  <input
                    type="text"
                    placeholder="Enter your Promotional code"
                    name="price"
                    value={formValues.promotionalCode}
                    onChange={({ target }) =>
                      setFormValues({
                        ...formValues,
                        promotionalCode: target.value,
                      })
                    }
                  />
                </div>
              )}

              <p>
                Want percentage discount for this course do you want to offer?
              </p>
              <div className="define-add-input price-inner-cost-inner">
                <input
                  type="text"
                  placeholder="Percentage"
                  name="percentage"
                  value={formValues.discountPercent}
                  onChange={({ target }) =>
                    setFormValues({
                      ...formValues,
                      discountPercent: target.value,
                    })
                  }
                />
              </div> */}
            </div>
          )}
        </div>
      </div>

      {storedSession === "liveCourse" && (
        <div
          className={`${
            coursebuilderToggle ? "align-box" : "align-box-1"
          } align-top`}
        >
          {current === 13 && (
            <div className="define-page">
              <h3 className="define-headeline">Course Scheduler</h3>
              <WebinarScheduler
                history={history}
                schedule={setFormValues}
                formValues={formValues}
                current={current}
              />
            </div>
          )}
        </div>
      )}
      {location !== "createBundle" && (
        <div
          className={`${
            coursebuilderToggle ? "align-box" : "align-box-1"
          } align-top`}
        >
          <div
            className={
              current === (storedSession === "liveCourse" ? 14 : 20)
                ? "define-page"
                : "occlude"
            }
          >
            <h3 className="define-headeline">
              {formValues.scheduleEvent === "event"
                ? CourseBuilderWebinar.submit.header
                : CourseBuilderStaticData.step18.header}
            </h3>
            <p>
              {formValues.scheduleEvent === "event"
                ? CourseBuilderWebinar.submit.subHeader
                : CourseBuilderStaticData.step18.subHeader1}
            </p>
            <p>
              {formValues.scheduleEvent === "event"
                ? CourseBuilderWebinar.submit.subHeader1
                : CourseBuilderStaticData.step18.subHeader2}
            </p>
            <p>
              {formValues.scheduleEvent === "event"
                ? CourseBuilderWebinar.submit.subHeader2
                : CourseBuilderStaticData.step18.subHeader3}
            </p>
            {storedSession !== "liveCourse" && (
              <>
                {!quizShow && (
                  <div
                    className={current === 20 ? "innerQuiz-button" : "occlude"}
                  >
                    <button
                      className="btn create-question create-no-quiz-1"
                      onClick={next}
                    >
                      CREATE A QUIZ NOW
                    </button>
                    <button
                      className="btn create-no-quiz-0"
                      onClick={() => setQuizShow(!quizShow)}
                    >
                      NO QUIZ,CONTINUE
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}

      {location !== "createBundle" && (
        <>
          {storedSession !== "liveCourse" && (
            <div
              className={`${
                coursebuilderToggle ? "align-box" : "align-box-1"
              } align-top`}
            >
              <div className={current === 21 ? "define-page" : "occlude"}>
                <h3 className="define-headeline">
                  {CourseBuilderStaticData.step19.header}
                </h3>
                <p>
                  {formValues.scheduleEvent === "event"
                    ? CourseBuilderWebinar.submit.subHeader
                    : CourseBuilderStaticData.step19.subHeader1}
                </p>
                <Quiz
                  setQuizCreation={setQuizCreation}
                  quizCreation={quizCreation}
                  history={history}
                  quizValidateMsg={quizValidateMsg}
                  setQuizValidateMsg={setQuizValidateMsg}
                  quizResponse={quizResponse}
                  setQuizResponse={setQuizResponse}
                  next={next}
                />
              </div>
            </div>
          )}
        </>
      )}

      {location !== "createBundle" && (
        <>
          {storedSession !== "liveCourse" && (
            <div
              className={`${
                coursebuilderToggle ? "align-box" : "align-box-1"
              } align-top`}
            >
              <div className={current === 22 ? "define-page" : "occlude"}>
                <h3 className="define-headeline">
                  {CourseBuilderStaticData.step20.header}
                </h3>
                <div className="quiz-eveny-0">
                  {!quizResponse && <Loading />}
                  {quizResponse && (
                    <>
                      <p style={{ marginBottom: "0px", margintop: "25px" }}>
                        {/* {formValues.scheduleEvent === "event"
                    ? CourseBuilderWebinar.submit.subHeader
                    : CourseBuilderStaticData.step20.header1} */}
                        {quizStatus}
                      </p>
                      {/* <p>
                  {formValues.scheduleEvent === "event"
                    ? CourseBuilderWebinar.submit.subHeader
                    : CourseBuilderStaticData.step20.header2}
                </p> */}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};
export default CourseBuilderMain;




